import { FC } from "react";
//import { PageViewportLayout } from "shared/components/template";
import { TeamFilterEditPropsT, TeamFilterEditView } from "./TeamFilterEditView";

export const TeamFilterEdit: FC<TeamFilterEditPropsT> = (props) => {        
    return (
        <>
        {/*<PageViewportLayout offsetTop={40}>*/}
            <TeamFilterEditView {...props} />
        {/*</PageViewportLayout>*/}
        </>
    );
};import { FC } from "react";
//import { PageViewportLayout } from "shared/components/template";
import { TeamFilterEditPropsT, TeamFilterEditView } from "./TeamFilterEditView";

export const TeamFilterEdit: FC<TeamFilterEditPropsT> = (props) => {        
    return (
        <>
        {/*<PageViewportLayout offsetTop={40}>*/}
            <TeamFilterEditView {...props} />
        {/*</PageViewportLayout>*/}
        </>
    );
};